import { render, staticRenderFns } from "./HeaderLabels.vue?vue&type=template&id=3c11d7f2&"
import script from "./HeaderLabels.vue?vue&type=script&lang=js&"
export * from "./HeaderLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports